import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Farmers from '../pages/HomePageBabies/Farmers';
import AllFarmers from '../pages/HomePageBabies/AllFarmers';
import Home from '../pages/HomePageBabies/Home';
import inputMarket from '../pages/HomePageBabies/inputmarket';
import Voucher from '../pages/HomePageBabies/Voucher';
import Employee from '../pages/HomePageBabies/Employee';
import Map from '../pages/HomePageBabies/Map'
import Bills from '../pages/HomePageBabies/Bills'
import AddSprayingProgram from "../pages/HomePageBabies/AddSprayingProgram";
import Chat from '../pages/HomePageBabies/Chat';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { checkCookie } from '../utils/Cookies';
import { isDashboard } from '../utils/Connections';
export default class MainPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleOpen: false
        }

    }

    componentDidMount() {
        if(checkCookie("accessToken")===""){
            this.props.history.push("/login")
        }
    }

    toggle() {
        const { toggleOpen } = this.state
        this.setState({ toggleOpen: !toggleOpen })
    }

    render() {
        return (
            <div id="wrapper">
                <Header history={this.props.history} toggleOpen={this.state.toggleOpen} onToggle={() => this.toggle()} />

                <Sidebar history={this.props.history} location={this.props.location} toggleOpen={this.state.toggleOpen} onClick={() => this.setState({ toggleOpen: false })} />

                {this.state.toggleOpen && <div onClick={() => this.setState({ toggleOpen: false })} className="sidebar-banner" />}
                <div className="main">
                    <Switch>
                        <Route path={'/farmers'} component={Farmers} exact />
                        <Route path={'/allfarmers'} component={AllFarmers} exact />
                        <Route path={'/input'} component={inputMarket} exact />
                        <Route path={'/voucher'} component={Voucher} exact />
                        <Route path={'/employee'} component={Employee} exact />
                        <Route path={'/map'} component={Map} exact />
                        <Route path={'/billing'} component={Bills} exact />
                        <Route path={'/suggestSpraying'} component={AddSprayingProgram} exact />
                        <Route path={'/'} component={Home} exact />
                    </Switch>
                </div>

                { !isDashboard() && <Chat />}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/MainPage.js